import { render, staticRenderFns } from "./wsTextViewer.vue?vue&type=template&id=b34e1a84&scoped=true&"
import script from "./wsTextViewer.vue?vue&type=script&lang=js&"
export * from "./wsTextViewer.vue?vue&type=script&lang=js&"
import style0 from "./wsTextViewer.vue?vue&type=style&index=0&id=b34e1a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34e1a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
